/****************************************************
 * Module Name:  utilityProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class UtilityProxy {

    static getDate = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/utility/getdate`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static getDateTime = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/utility/getdatetime`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static pingServer = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/ping`,
            "get",
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    }

}